module.exports = __webpack_public_path__ + "img/14.missing_paper_towel.2be1c990.svg";